import { createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { client } from 'src/graphql/client';
import {
  GET_DRIVER_LOCATION_TRAIL,
  DriverLocationPing,
  GetDriverLocationTrailQuery,
} from 'src/graphql/requests/getDriverLocationTrail';
import { DeliveryState } from './state';

type getDriverLocationTrailArgs = {
  routeId: string;
};

export const getDriverLocationTrail = createAsyncThunk(
  'delivery/driverLocationTrail',
  async ({
    routeId,
  }: getDriverLocationTrailArgs): Promise<DriverLocationPing[]> => {
    const { data, error } = await client
      .query<GetDriverLocationTrailQuery>(
        GET_DRIVER_LOCATION_TRAIL,
        { input: { routeId } },
        { requestPolicy: 'network-only' },
      )
      .toPromise();
    if (error || !data?.driverLocationTrail) {
      console.error('no driver location trail returned', error);
      return [];
    }
    return data.driverLocationTrail;
  },
);

export const getDriverLocationTrailFulfilled = (
  state: DeliveryState,
  action: PayloadAction<DriverLocationPing[]>,
): void => {
  state.driverLocationTrail = action.payload;
  state.driverLocationTrailLoading = false;
};

export const getDriverLocationTrailPending = (state: DeliveryState): void => {
  state.driverLocationTrailLoading = true;
};

export const getDriverLocationTrailRejected = (state: DeliveryState): void => {
  state.driverLocationTrailLoading = false;
};
